import React from "react";
import { safeLocalFormat } from "../../../utilities/functions";

const LocalDateEnd = ({ row }) => {
  return (
    <div>
      {row.endDate ? <>{safeLocalFormat(row?.endDate)}</> : <>not specific</>}
    </div>
  );
};

export default LocalDateEnd;
